import { ErrorHandlerObject } from "./types"

// type guard to identify that is an ErrorHandlerObject
export function isErrorHandlerObject(value: any): value is ErrorHandlerObject {
    if (typeof value === "object") {
        return value.hasOwnProperty("message")
    }
    return false
}